module.exports = __webpack_public_path__ + "img/CLASSIFIED.0439e2fa.png";